import React, { PureComponent } from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';
import ModalHeader from 'react/components/Modal/ModalHeader';
import ModalTitle from 'react/components/Modal/ModalTitle';
import ModalCloseIcon from 'react/components/Modal/ModalCloseIcon';

class Modal extends PureComponent {
  componentWillUnmount() {
    this.reactModalRef.componentWillUnmount = () => {};
  }

  render() {
    const {
      title,
      subtitle,
      header,
      footer,
      closeModalFn,
      className,
      closeTimeoutMS,
      children,
      loader,
      toaster,
      style,
      styles,
      crossAxisBtn,
      containerSelector,
      ...others
    } = this.props;
    return (
      <ReactModal
        ref={(ref) => (this.reactModalRef = ref)} // eslint-disable-line no-return-assign
        className={{
          base: `generic-modal ${className || ''}`,
          afterOpen: 'generic-modal--after-open',
          beforeClose: 'generic-modal--before-close'
        }}
        ariaHideApp={false}
        portalClassName="generic-modal-portal"
        bodyOpenClassName="generic-modal--is-open"
        overlayClassName={{
          base: 'generic-modal-overlay',
          afterOpen: 'generic-modal-overlay--after-open',
          beforeClose: 'generic-modal-overlay--before-close'
        }}
        closeTimeoutMS={closeTimeoutMS}
        style={style || styles.base}
        // eslint-disable-next-line new-cap
        parentSelector={() =>
          document.getElementById(
            `${containerSelector || Monet.Utils.GetTabName()}`
          ) || document.body
        }
        {...others}
      >
        {loader && (
          <div className="generic-modal__modal-loader-container">{loader}</div>
        )}
        <div className="generic-modal__modal-header-container">
          {header || (
            <ModalHeader
              leftArea={<ModalTitle title={title} subtitle={subtitle} />}
              rightArea={
                crossAxisBtn ? <ModalCloseIcon onClick={closeModalFn} /> : ''
              }
            />
          )}
        </div>
        <div className="generic-modal__modal-body-container">
          <div className="generic-modal__modal-toaster-container">
            {toaster}
          </div>
          <div className="generic-modal__modal-body">{children}</div>
        </div>
        {footer && (
          <div className="generic-modal__modal-footer-container">{footer}</div>
        )}
      </ReactModal>
    );
  }
}

Modal.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  header: PropTypes.node,
  footer: PropTypes.node,
  loader: PropTypes.node,
  toaster: PropTypes.node,
  closeModalFn: PropTypes.func.isRequired,
  closeTimeoutMS: PropTypes.number,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  style: PropTypes.objectOf(PropTypes.any),
  styles: PropTypes.objectOf(PropTypes.any),
  containerSelector: PropTypes.string,
  crossAxisBtn: PropTypes.bool
};

Modal.defaultProps = {
  title: '',
  subtitle: '',
  style: {},
  styles: {},
  header: null,
  footer: null,
  loader: null,
  toaster: null,
  closeTimeoutMS: 150,
  className: '',
  children: null,
  crossAxisBtn: true,
  containerSelector: null
};

export default Modal;
